// extracted by mini-css-extract-plugin
export default {"slider":"Cargando_slider__D8uCN","slider-o":"Cargando_slider-o__nIwAX","cargando":"Cargando_cargando__7DuGI"};